import React from 'react';
import { useNavigate, Link } from 'react-router-dom';

const RequestDetailSent = () => {
    const navigate = useNavigate();
    const handleBack = () => {
        navigate('/backoffice'); // This will go back one step in history
    };
    return (
        <section className="container1">
            <a className="btn_back" onClick={handleBack}>
                Volver al home
            </a>
            <section>
                <div className="sol_sent">
                    <h2>Solicitud aprobada con éxito</h2>
                    <p>La solicitud fue aprobada correctamente y le enviaremos la notificación correspondiente al usuario. </p>                    
                </div>
            </section>
        </section>
    );
};

export default RequestDetailSent;
